module.exports = __webpack_public_path__ + "static/media/Nova-Carriers-banner.43cde26f.jpg";